import React from 'react'

const TriangleDown: React.FC = () => (
  <svg
    className="rn-arrow"
    width="11px"
    height="8px"
    viewBox="0 0 11 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-255.000000, -19.000000)"
        className="rn-arrow__fill"
      >
        <path d="M259.675958,25.8013936 L255.538494,19.7832644 C255.382052,19.5557115 255.439698,19.2444217 255.667251,19.087979 C255.7506,19.0306765 255.849368,19 255.950515,19 L265.049485,19 C265.325627,19 265.549485,19.2238576 265.549485,19.5 C265.549485,19.6011468 265.518808,19.6999152 265.461506,19.7832644 L261.324042,25.8013936 C261.011157,26.2564994 260.388577,26.3717919 259.933471,26.0589067 C259.832595,25.9895544 259.74531,25.9022696 259.675958,25.8013936 Z" />
      </g>
    </g>
  </svg>
)

TriangleDown.displayName = 'TriangleDownIcon'

export default TriangleDown
